import PropTypes from 'prop-types';
import { TimePicker as TimePickerMui } from '@mui/x-date-pickers/TimePicker';
import Stack from '@mui/material/Stack';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

const TimePicker = (props) => {
	const { label, error, helperText, ...rest } = props;

	return (
		<Stack spacing={1}>
			{label && <InputLabel>{label}</InputLabel>}
			<FormControl>
				<TimePickerMui
					openTo="hours"
					views={['hours', 'minutes']}
					format="HH:mm"
					ampm={false}
					sx={{
						' .MuiInputBase-root fieldset': {
							borderColor: error ? 'error.main' : undefined,
						},
					}}
					{...rest}
				/>
				{error && <FormHelperText error>{error}</FormHelperText>}
				{helperText && <FormHelperText>{helperText}</FormHelperText>}
			</FormControl>
		</Stack>
	);
};

TimePicker.propTypes = {
	...TimePickerMui.propTypes,
	label: PropTypes.string,
	error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	helperText: PropTypes.string,
};

export default TimePicker;
